import subjectMaker from 'reducersMakers/subjectMaker';
import * as actions from 'actions';

export default subjectMaker({
  updateType: actions.FORUM_CONTRIBUTE_EDITING_UPDATE_SUBJECT,
  resetType: actions.FORUM_CONTRIBUTE_EDITING_RESET
});



/** WEBPACK FOOTER **
 ** ./src/members/state/forum/contributeSubject/reducer.js
 **/